import { API } from "./../../../api/config";

export const getYearOptionsAPI = () => {
    return API.get("/pmbpartner/month-lock/get-years")
              .then((res) => res);
};

export const getMonthLocksAPI = (params) => {
    return API.get("/pmbpartner/month-lock/get", { params })
              .then((res) => res);
};

export const lockMonthAPI = (payload) => {
    return API.post("/pmbpartner/month-lock/create", payload)
              .then((res) => res);
};

export const updateMonthlockAPI = (payload) => {
    return API.patch(`/pmbpartner/month-lock/update/${payload.monthId}`, payload?.payload)
              .then((res) => res);
};